import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

interface IPaymentOfferPopup {
    openDialog: boolean;
    handleCloseDialog: () => void;
}

export const PaymentOfferPopup = (props: IPaymentOfferPopup): React.JSX.Element => {
    const {openDialog, handleCloseDialog} = props;
    return (
        <Dialog maxWidth="lg" open={openDialog} onClose={handleCloseDialog}>
            <DialogTitle>Оферта</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <div className={'payment-description'}>
                        <div>
                            <h4>Платежи. Оплата банковской картой онлайн</h4>
                            <p>
                                Наш сайт подключён к интернет-эквайрингу, и Вы можете оплатить Услугу банковской картой Visa или Mastercard.
                                После подтверждения выбранного Товара либо услуги откроется защищённое окно с платёжной страницей АО Банк
                                ЦентрКредит, где Вам необходимо будет ввести данные Вашей банковской карты. Для дополнительной аутентификации
                                держателя карты используется протокол 3-D Secure. Если Ваш Банк-эмитент поддерживает данную технологию, Вы
                                будете перенаправлены на его сервер для прохождения дополнительной идентификации. Информацию о правилах и
                                методах дополнительной идентификации уточняйте в Банке, выдавшем Вам банковскую карту.
                            </p>
                            <p>
                                Услуга онлайн-оплаты осуществляется в соответствии с правилами Международных платёжных систем Visa и MasterCard
                                на принципах соблюдения конфиденциальности и безопасности совершения платежа. Для этого используются самые
                                актуальные методы проверки, шифрования, и передачи данных по закрытым каналам связи. Ввод данных банковской
                                карты осуществляется в защищённом окне на платёжной странице АО Банк ЦентрКредит.
                            </p>
                            <p>
                                В поля на платёжной странице потребуется ввести номер карты, имя владельца карты, срок действия карты,
                                трёхзначный код безопасности (CVV2 для VISA или CVC2 для MasterCard). Все необходимые данные отображены на
                                поверхности банковской карты.
                            </p>
                            <p>CVV2/ CVC2 — это трёхзначный код безопасности, находящийся на оборотной стороне карты.</p>
                            <p>
                                Далее в том же окне откроется страница Вашего банка-эмитента для ввода 3-D Secure кода. В случае, если у вас не
                                настроен статичный 3-D Secure, он будет отправлен на ваш номер телефона посредством SMS. Если 3-D Secure код к
                                Вам не пришёл, то следует обратиться в ваш банк-эмитент.
                            </p>
                            <p>
                                3-D Secure — это самая современная технология обеспечения безопасности платежей по картам в сети интернет. Она
                                позволяет однозначно идентифицировать подлинность держателя карты, осуществляющего операцию, и максимально
                                снизить риск мошеннических операций по карте.
                            </p>
                        </div>
                        <div>
                            <h4>Гарантии безопасности</h4>
                            <p>
                                АО Банк ЦентрКредит защищает и обрабатывает данные Вашей банковской карты по стандарту безопасности PCI DSS 3.0.
                                Передача информации в платёжный шлюз происходит с применением технологии шифрования SSL. Дальнейшая передача
                                информации происходит по закрытым банковским сетям, имеющим наивысший уровень надёжности. АО Банк ЦентрКредит не
                                передаёт данные Вашей карты нам и иным третьим лицам. Для дополнительной аутентификации держателя карты
                                используется протокол 3-D Secure.
                            </p>
                            <p>
                                В случае, если у Вас есть вопросы по совершённому платежу, Вы можете обратиться в службу поддержки клиентов
                                платёжного сервиса по электронной почте portpvl01@gmail.com.
                            </p>
                        </div>
                        <div>
                            <h4>Безопасность онлайн-платежей</h4>
                            <p>
                                Предоставляемая Вами персональная информация (имя, адрес, телефон, e-mail, номер кредитной карты) является
                                конфиденциальной и не подлежит разглашению. Данные Вашей кредитной карты передаются только в зашифрованном виде
                                и не сохраняются на нашем Web-сервере.
                            </p>
                            <p>
                                Безопасность обработки Интернет-платежей гарантирует АО Банк ЦентрКредит. Все операции с платёжными картами
                                происходят в соответствии с требованиями VISA International, MasterCard, и других платёжных систем. При передаче
                                информации используются специализированные технологии безопасности карточных онлайн-платежей, обработка данных
                                ведётся на безопасном высокотехнологичном сервере процессинговой компании.
                            </p>
                            <p>Оплата платёжными картами безопасна, потому что:</p>
                            <ul>
                                <li>
                                    Система авторизации гарантирует покупателю, что платёжные реквизиты его платёжной карты (номер, срок
                                    действия, CVV2/CVC2) не попадут в руки мошенников, так как эти данные не хранятся на сервере авторизации, и
                                    не могут быть похищены.
                                </li>
                                <li>
                                    Покупатель вводит свои платёжные данные непосредственно в системе авторизации АО Банк ЦентрКредит, а не на
                                    сайте интернет-магазина, следовательно, платёжные реквизиты карточки покупателя не будут доступны третьим
                                    лицам.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h4>Возврат денежных средств</h4>
                            <p>
                                При совершении оплаты услуга считается оказанной в полном объёме, и, согласно договору Оферты, перерасчёту,
                                возврату или обмену не подлежит.
                            </p>
                            <p>Случаи отказа в совершении платежа:</p>
                            <ul>
                                <li>
                                    банковская карта не предназначена для совершения платежей через интернет, о чём можно узнать, обратившись в
                                    Ваш Банк-эмитент;
                                </li>
                                <li>
                                    недостаточно средств для оплаты на банковской карте. Подробнее о наличии средств на платёжной карте Вы
                                    можете узнать, обратившись в банк, выпустивший банковскую карту;
                                </li>
                                <li>данные банковской карты введены неверно;</li>
                                <li>
                                    истёк срок действия банковской карты. Срок действия карты, как правило, указан на лицевой стороне карты (это
                                    месяц и год, до которого действительна карта). Подробнее о сроке действия карты Вы можете узнать,
                                    обратившись в банк-эмитент.
                                </li>
                            </ul>
                            <p>
                                По вопросам оплаты с помощью банковской карты, или иным вопросам, связанным с работой сайта, Вы можете
                                обратиться по следующим телефонам: 7 (7182) 32-14-05, +7 (7182) 32-67-31.
                            </p>
                        </div>
                        <div>
                            <h4>Конфиденциальность</h4>
                            <p>1. Определения</p>
                            <p>
                                Интернет проект https://streampay.kkmport.kz/ (далее – URL, «мы») серьёзно относится к вопросу
                                конфиденциальности информации своих клиентов и посетителей сайта (далее – «вы», «посетители сайта»).
                                Персонифицированной мы называем информацию, содержащую персональные данные (например, ФИО, логин или название
                                компании) посетителя сайта, а также информацию о действиях, совершаемых вами на сайте URL (например, заказ
                                посетителя сайта с его контактной информацией). Анонимными мы называем данные, по которым невозможно однозначно
                                идентифицировать конкретного посетителя сайта (например, статистика посещаемости сайта).
                            </p>
                            <p>2. Использование информации</p>
                            <p>
                                Мы используем персонифицированную информацию конкретного посетителя сайта исключительно для обеспечения ему
                                качественного оказания услуг и их учёта. Мы не раскрываем персонифицированных данных одних посетителей сайта URL
                                другим посетителям сайта. Мы никогда не публикуем персонифицированную информацию в открытом доступе, и не
                                передаём её третьим лицам. Исключением являются лишь ситуации, когда предоставление такой информации
                                уполномоченным государственным органам предписано действующим законодательством Республики Казахстан. Мы
                                публикуем и распространяем только отчёты, построенные на основании собранных анонимных данных. При этом отчёты
                                не содержат информацию, по которой было бы возможно идентифицировать персонифицированные данные пользователей
                                услуг. Мы также используем анонимные данные для внутреннего анализа, целью которого является развитие продуктов
                                и услуг URL.
                            </p>
                            <p>3. Ссылки</p>
                            <p>
                                Сайт https://streampay.kkmport.kz/ может содержать ссылки на другие сайты, не имеющие отношения к нашей
                                компании, и принадлежащие третьим лицам. Мы не несём ответственности за точность, полноту и достоверность
                                сведений, размещённых на сайтах третьих лиц, и не берём на себя никаких обязательств по сохранению
                                конфиденциальности информации, оставленной вами на таких сайтах.
                            </p>
                            <p>4. Ограничение ответственности</p>
                            <p>
                                Мы делаем всё возможное для соблюдения настоящей политики конфиденциальности, однако мы не можем гарантировать
                                сохранность информации в случае воздействия факторов, находящихся вне нашего влияния, результатом действия
                                которых станет раскрытие информации. Сайт https://streampay.kkmport.kz/ и вся размещённая на нём информация
                                представлены по принципу "как есть" без каких-либо гарантий. Мы не несём ответственности за неблагоприятные
                                последствия, а также за любые убытки, причинённые вследствие ограничения доступа к сайту URL, или вследствие
                                посещения сайта и использования размещённой на нём информации.
                            </p>
                            <p>5. Контакты</p>
                            <div>
                                По вопросам, касающимся настоящей политики, просьба обращаться по адресу &nbsp;
                                <a href={'mailto:portpvl01@gmail.com'}>portpvl01@gmail.com</a>
                            </div>
                            <p />

                            <h4>Юридическое лицо</h4>
                            <p>
                                <div>ТОО&nbsp;«ГК&nbsp;ПОРТ»</div>
                                <div>Республика Казахстан, 140000</div>
                                <div>Юр.&nbsp;адрес: г.&nbsp;Павлодар, ул.&nbsp;Каирбаева, 36-81</div>
                                <div>Адрес местонахождения: г.&nbsp;Павлодар, ул.&nbsp;Каирбаева, 36-81</div>
                                <div>Тел. 8&nbsp;(7182)&nbsp;32-14-05, 32-67-31</div>
                                <div>БИН 150340020321</div>
                                <div>
                                    Е-mail: <a href={'mailto:portpvl01@gmail.com'}>portpvl01@gmail.com</a>; /
                                    <a href={'//www.kkmport.kz'}>www.kkmport.kz</a>/
                                </div>
                            </p>
                        </div>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog}>Закрыть</Button>
            </DialogActions>
        </Dialog>
    );
};
